<div class="container">
    <div class="row">
        <div *ngFor="let categoria of modelos | keyvalue; let last = last; let i = index" class="col-12 col-md-3 col-lg-3">
            <div class="float-start">
                <h3 class="ff-medium text-uppercase fw-semibold fs-6 py-3">{{ formatKey(categoria.key) }}</h3>
                <div class="row">
                    <ul class="list-models">
                        <li *ngFor="let modelo of categoria.value" class="mb-2">
                            <a [routerLink]="[categoria.key, modelo.modelo_url]" class="text-uppercase ff-medium" (click)="cerrarMenu()">{{ modelo.nombre_modelo }}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div style="border-left: 1px solid #000; height: 180px;" class="float-end" *ngIf="!last"></div>
        </div>
        
    </div>
</div>
